import React from 'react';

const LoadingComman = () => {
  return (
    <div className="w-full h-screen flex items-center justify-center bg-white absolute top-0 left-0 z-[999999]">
      <div className="flex items-center justify-center">
        <div className="relative inline-block w-20 h-20">
          <div className="absolute top-[33.33333px] left-2 w-[13.33333px] h-[13.33333px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis1 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <div className="absolute top-[33.33333px] left-2 w-[13.33333px] h-[13.33333px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis2 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <div className="absolute top-[33.33333px] left-8 w-[13.33333px] h-[13.33333px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis2 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <div className="absolute top-[33.33333px] left-14 w-[13.33333px] h-[13.33333px] rounded-full bg-black"
            style={{ animation: 'lds-ellipsis3 0.6s cubic-bezier(0, 1, 1, 0) infinite' }}></div>

          <style jsx global>{`
            @keyframes lds-ellipsis1 {
              0% { transform: scale(0); }
              100% { transform: scale(1); }
            }
            
            @keyframes lds-ellipsis3 {
              0% { transform: scale(1); }
              100% { transform: scale(0); }
            }
            
            @keyframes lds-ellipsis2 {
              0% { transform: translate(0, 0); }
              100% { transform: translate(24px, 0); }
            }
          `}</style>
        </div>
      </div>
    </div>
  );
};

export default LoadingComman;